import * as React from "react";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "../../../../../../../components/Tabs/TabPanel.component";
import SimpleTab from "../../../../../../../components/Tabs/SimpleTab";
import DesignDataPanel from "./Panels/DesignDataPanel";
import MaterialPanel from "./Panels/MaterialPanel";
import ShellPanel from "./Panels/ShellPanel";
import NozzlesPanel from "./Panels/NozzlesPanel";

const inputDataTabs = [
  { label: "Design Data", panel: <DesignDataPanel /> },
  { label: "Material", panel: <MaterialPanel /> },
  { label: "Shell", panel: <ShellPanel /> },
  { label: "Nozzles", panel: <NozzlesPanel /> },
  { label: "Attachments", panel: <></> },
  { label: "Spec", panel: <></> },
  { label: "Notes", panel: <></> },
  { label: "Revision Table", panel: <></> },
];

export default function InputDataTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <SimpleTab
          tabs={inputDataTabs.map((t) => t.label)}
          value={value}
          setValue={setValue}
          sx={{ fontSize: 16 }}
        />
      </Box>

      {inputDataTabs.map((t, i) => {
        return (
          <TabPanel value={value} index={i} key={t.label}>
            {t.panel}
          </TabPanel>
        );
      })}
    </Box>
  );
}
